/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *  - UNSPECIFIED: Default value if not present.
 *  - OK: Indicates successful reporting.
 *  - INVALID_ARGUMENT: Indicates that the payload of the metric is invalid.
 *  - DUPLICATE_REPORTING: Indicates that the metric has been reported before.
 *  - INTERNAL_ERROR: Indicates that something went wrong in the server.
 * @export
 */
export const ReportRunMetricsResponseReportRunMetricResultStatus = {
  UNSPECIFIED: 'UNSPECIFIED',
  OK: 'OK',
  INVALID_ARGUMENT: 'INVALID_ARGUMENT',
  DUPLICATE_REPORTING: 'DUPLICATE_REPORTING',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
} as const;
export type ReportRunMetricsResponseReportRunMetricResultStatus =
  (typeof ReportRunMetricsResponseReportRunMetricResultStatus)[keyof typeof ReportRunMetricsResponseReportRunMetricResultStatus];

export function instanceOfReportRunMetricsResponseReportRunMetricResultStatus(value: any): boolean {
  for (const key in ReportRunMetricsResponseReportRunMetricResultStatus) {
    if (
      Object.prototype.hasOwnProperty.call(ReportRunMetricsResponseReportRunMetricResultStatus, key)
    ) {
      if (
        ReportRunMetricsResponseReportRunMetricResultStatus[
          key as keyof typeof ReportRunMetricsResponseReportRunMetricResultStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ReportRunMetricsResponseReportRunMetricResultStatusFromJSON(
  json: any,
): ReportRunMetricsResponseReportRunMetricResultStatus {
  return ReportRunMetricsResponseReportRunMetricResultStatusFromJSONTyped(json, false);
}

export function ReportRunMetricsResponseReportRunMetricResultStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ReportRunMetricsResponseReportRunMetricResultStatus {
  return json as ReportRunMetricsResponseReportRunMetricResultStatus;
}

export function ReportRunMetricsResponseReportRunMetricResultStatusToJSON(
  value?: ReportRunMetricsResponseReportRunMetricResultStatus | null,
): any {
  return value as any;
}

export function ReportRunMetricsResponseReportRunMetricResultStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ReportRunMetricsResponseReportRunMetricResultStatus {
  return value as ReportRunMetricsResponseReportRunMetricResultStatus;
}
